<section class="comments-section">
  <div class="comments-header">
    <div class="title">
      {{info?.commentsSection?.header?.title}}
    </div>
    <div class="sub-title">
      {{info?.commentsSection?.header?.subTitle}}
    </div>
    <div class="desc">
      {{info?.commentsSection?.header?.desc}}
    </div>
  </div>
  <app-hf-comments [comments]="info?.commentsSection?.comments"></app-hf-comments>
</section>